import { render, staticRenderFns } from "./OverviewData.vue?vue&type=template&id=3028653c&scoped=true"
import script from "./OverviewData.vue?vue&type=script&lang=ts"
export * from "./OverviewData.vue?vue&type=script&lang=ts"
import style0 from "./card.less?vue&type=style&index=0&id=3028653c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028653c",
  null
  
)

export default component.exports